import {Checkbox, CheckboxProps, Modal, notification} from "antd";
import {useQuoteContext} from "../../contexts/QuoteContext";
import useQuote from "../../swr/useQuote";
import {useIntl} from "react-intl";
import React, {useContext} from "react";
import {ConfiguratorContext} from "../../context";
import {ExclamationCircleFilled} from "@ant-design/icons";
import {Quote} from "../../api/models";
import Configurator from "../../pages/configurator";

const DisableEpicorCheckbox = (props:CheckboxProps) => {

    const { quote} = useQuoteContext();
    const quoteAsync = useQuote({ quoteId: quote?.quoteId, revision: quote?.revision });

    const intl = useIntl();
    const configurator = useContext(ConfiguratorContext);

    const handleDisableEpicor = (enabled: boolean) => {
        if ( !quote ) return;

        if ( enabled ) {
            Modal.confirm({
                title: 'Are you sure?',
                icon: <ExclamationCircleFilled />,
                content: 'This will prevent this order from syncing with Epicor.',
                onOk: () => toggleEpicor(quote, enabled),
            });
        }
        else {
            Modal.confirm({
                title: 'Are you sure?',
                icon: <ExclamationCircleFilled />,
                content: 'This will enable epicor syncing.  Please verify why it was originally disabled.',
                onOk: () => toggleEpicor(quote, enabled),
            });
        }
    }

    const toggleEpicor = async (quote:Quote, enabled:boolean) => {

        try {

            const resp = await configurator.api.updateQuoteRevision(quote?.displayRevisionId, quote.version, { epicorDisabled: enabled});
            await quoteAsync.mutate(resp.data);

        } catch (e:any) {
            const errorMsg = intl.formatMessage({ id: e.message });
            notification.error( { message: "Failed to updateQuote. " + errorMsg });
        }
    }

    return <div style={{textAlign: "center"}}>
        <label >
            <Checkbox
                {...props}
                checked={quote?.epicorDisabled}
                onChange={(e) => handleDisableEpicor(e.target.checked)}
                style={{padding:0}}
            />
            <span style={{marginLeft: "0.5rem"}}>Disable Epicor</span>
        </label>
    </div>
}

export default DisableEpicorCheckbox;
